import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormGroup from 'reactstrap/lib/FormGroup';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { PASSWORD_MAX_LENGTH } from 'site-modules/shared/components/profile/smart-sign/helper';

const ERROR_CODES = {
  oldPassword: ['auth/wrong-password'],
  newPassword: ['auth/weak-password'],
  confirmPassword: ['auth/weak-password'],
};

export function PasswordInput({ name, value, onChange, label, validationClass = null, errorCode = null }) {
  const firebaseInvalidPassword = ERROR_CODES[name].includes(errorCode);
  const [type, toggleType] = useToggle(true);

  return (
    <FormGroup
      className={classnames(
        'form-input d-flex flex-column flex-md-row align-items-md-center',
        validationClass,
        {
          'has-danger': firebaseInvalidPassword,
        },
        'form-group'
      )}
      noMargin
    >
      <Label className="text-nowrap m-0" for={name}>
        {label}
      </Label>
      <div className="pos-r w-100">
        {/* todo - review PLAT-3859 disabling */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a role="button" tabIndex={0} className="show-password-icon text-gray py-0_25" onClick={toggleType}>
          <i className="icon-eye me-0_75" aria-hidden />
        </a>
        <Input
          value={value}
          type={type ? 'password' : 'text'}
          onChange={onChange}
          name={name}
          id={name}
          maxLength={PASSWORD_MAX_LENGTH}
        />
      </div>
    </FormGroup>
  );
}

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  validationClass: PropTypes.string,
  errorCode: PropTypes.string,
};
